import { useState } from 'react'
import { Button } from 'reactstrap'
import { publishEvent } from '../../utils'


export default function UserAttributeRow({ attribute }) {
  //console.log('UserAttributesRow rendered: ', attribute)

  const [localAttribute, setLocalAttribute] = useState(attribute)
  
  function editButtonClicked(targetAttribute) {
    console.log('UserAttributeRow.editButtonClicked: ', targetAttribute)
    const newAttribute = JSON.parse(JSON.stringify(targetAttribute))
    newAttribute.updateRow = setLocalAttribute
    publishEvent('OPEN USER ATTRIBUTE MODAL', newAttribute, 'UserAttributeRow.editButtonClicked')
  }

  return (
    <tr style={{ textAlign: 'left' }}>
      <td><Button color="warning" size="sm" onClick={(e) => editButtonClicked(localAttribute)}>Edit</Button></td>
      <td>{localAttribute.name}</td>
      <td>{localAttribute.defaultValue}</td>
      <td>{localAttribute.value}</td>
    </tr>
  )
}
